module.exports = {"130725100":"南壕堑镇","130725101":"大青沟镇","130725102":"八道沟镇","130725103":"红土梁镇","130725104":"小蒜沟镇","130725105":"三工地镇","130725106":"满井镇","130725200":"大营盘乡","130725201":"大苏计乡","130725202":"石井乡","130725205":"七甲乡","130725206":"套里庄乡","130725207":"甲石河乡","130725208":"下马圈乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130725.json
// module id = 188
// module chunks = 0